import fold from '../../../../../audio/audioFiles/soundMachine/fold.mp3'
import microscope from '../../../../../audio/audioFiles/soundMachine/microscope.mp3'
import page from '../../../../../audio/audioFiles/soundMachine/page.mp3'
import triangle from '../../../../../audio/audioFiles/soundMachine/triangle.mp3'
import on from '../../../../../audio/audioFiles/soundMachine/on.mp3'
import lamp from '../../../../../audio/audioFiles/soundMachine/lamp.mp3'
import click from '../../../../../audio/audioFiles/soundMachine/click.mp3'
import six from '../../../../../audio/audioFiles/soundMachine/six.mp3'
import double from '../../../../../audio/audioFiles/soundMachine/double.mp3'
import the from '../../../../../audio/audioFiles/soundMachine/the.mp3'
import globe from '../../../../../audio/audioFiles/soundMachine/globe.mp3'
import turn from '../../../../../audio/audioFiles/soundMachine/turn.mp3'

import soundWave0 from '../../../../../images/puzzles/laboratory/soundwaves/soundWave0.png'
import soundWave1 from '../../../../../images/puzzles/laboratory/soundwaves/soundWave1.png'
import soundWave2 from '../../../../../images/puzzles/laboratory/soundwaves/soundWave2.png'
import soundWave3 from '../../../../../images/puzzles/laboratory/soundwaves/soundWave3.png'
import soundWave4 from '../../../../../images/puzzles/laboratory/soundwaves/soundWave4.png'
import soundWave5 from '../../../../../images/puzzles/laboratory/soundwaves/soundWave5.png'
import soundWave6 from '../../../../../images/puzzles/laboratory/soundwaves/soundWave6.png'
import soundWave7 from '../../../../../images/puzzles/laboratory/soundwaves/soundWave7.png'
import soundWave8 from '../../../../../images/puzzles/laboratory/soundwaves/soundWave8.png'
import soundWave9 from '../../../../../images/puzzles/laboratory/soundwaves/soundWave9.png'
import soundWave10 from '../../../../../images/puzzles/laboratory/soundwaves/soundWave10.png'
import soundWave11 from '../../../../../images/puzzles/laboratory/soundwaves/soundWave11.png'

const soundwaveData = [
    {
        img: soundWave2,
        audio: fold,
        text: 'fold'
    },
    {
        img: soundWave3,
        audio: microscope,
        text: 'microscope'
    },
    {
        img: soundWave4,
        audio: page,
        text: 'page'
    },
    {
        img: soundWave5,
        audio: triangle,
        text: 'triangle'
    },
    {
        img: soundWave1,
        audio: on,
        text: 'on'
    },
    {
        img: soundWave6,
        audio: lamp,
        text: 'lamp'
    },
    {
        img: soundWave0,
        audio: click,
        text: 'click'
    },
    {
        img: soundWave7,
        audio: six,
        text: 'six'
    },
    {
        img: soundWave8,
        audio: double,
        text: 'double'
    },
    {
        img: soundWave10,
        audio: the,
        text: 'the'
    },
    {
        img: soundWave9,
        audio: globe,
        text: 'globe'
    },
    {
        img: soundWave11,
        audio: turn,
        text: 'turn'
    },
]

export default soundwaveData